import { ContentType } from '../../models/enums/content-type.enum';
import { CourseStatus } from '../../models/enums/course-status.enum';
import { CourseType } from '../../models/enums/course-type.enum';
import { CourseLocation } from '../../models/enums/course-location.enum';
import { Course } from '../../models/interfaces/course.interface';
import { categoriesMock } from './category.mock';
import { tagsMock } from './tag.mock';

const moduleIntroOrder = 0;
const moduleAdvancedOrder = 1;

const now = new Date();
const tenHoursAgo = new Date(now.getTime() - 10 * 60 * 60 * 1000);

const courseId = 'course-uuid';
const moduleIntroId = 'module-uuid-1';
const moduleAdvancedId = 'module-uuid-2';
const classWelcomeId = 'content-uuid-1';

export const courseMock: Course = {
  id: courseId,
  createdAt: now,
  updatedAt: now,
  isActive: true,
  deletedAt: null,
  tenantId: 'tenant-uuid',
  title: 'Angular Avançado',
  description: 'Curso avançado de Angular',
  shortDescription: 'Domine recursos avançados do Angular',
  durationMinutes: 720,
  type: CourseType.COURSE,
  location: CourseLocation.ONLINE,
  coverImageUrl: 'https://picsum.photos/seed/angular-advanced/640/360',
  category: categoriesMock[0],
  tags: tagsMock.slice(0, 2),
  groupIds: ['group-uuid'],
  trackIds: ['track-uuid'],
  status: CourseStatus.ACTIVE,
  modules: [
    {
      id: moduleIntroId,
      createdAt: now,
      updatedAt: now,
      order: moduleIntroOrder,
      title: 'Introdução ao Angular',
      courseId,
      duration: 0,
      classesIds: [classWelcomeId],
      isActive: true,
    },
    {
      id: moduleAdvancedId,
      createdAt: now,
      updatedAt: now,
      order: moduleAdvancedOrder,
      title: 'Padrões avançados',
      courseId,
      duration: 0,
      classesIds: [],
      isActive: false,
    },
  ],
  contents: [
    {
      id: 'content-module-1',
      createdAt: now,
      updatedAt: now,
      isActive: true,
      moduleId: moduleIntroId,
      moduleOrder: moduleIntroOrder,
      classes: [
        {
          id: classWelcomeId,
          createdAt: now,
          updatedAt: now,
          isActive: true,
          order: 0,
          title: 'Boas-vindas ao curso',
          type: ContentType.RICH_TEXT,
          editorContent: '<p>Conteúdo inicial do módulo introdutório.</p>',
        },
      ],
      evaluations: [],
    },
    {
      id: 'content-module-2',
      createdAt: now,
      updatedAt: now,
      isActive: true,
      moduleId: moduleAdvancedId,
      moduleOrder: moduleAdvancedOrder,
      classes: [],
      evaluations: [
        {
          id: 'evaluation-uuid-1',
          createdAt: now,
          updatedAt: now,
          isActive: true,
          order: 0,
          questions: [
            {
              id: 'question-uuid-1',
              createdAt: now,
              updatedAt: now,
              isActive: true,
              order: 0,
              text: 'Qual é o principal benefício de usar standalone components?',
              options: [
                {
                  id: 'option-uuid-1',
                  createdAt: now,
                  updatedAt: now,
                  isActive: true,
                  order: 0,
                  text: 'Menos boilerplate de módulos',
                  isCorrect: true,
                },
                {
                  id: 'option-uuid-2',
                  createdAt: now,
                  updatedAt: now,
                  isActive: true,
                  order: 1,
                  text: 'Mais arquivos de configuração',
                  isCorrect: false,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

const courseTitles = [
  'Angular',
  'React',
  'Vue',
  'Node.js',
  'TypeScript',
  'JavaScript',
  'HTML e CSS',
  'Arquitetura de Software',
  'Testes Automatizados',
  'CI e CD',
  'Clean Code',
  'Design Patterns',
  'Banco de Dados',
  'APIs REST',
  'Seguranca Aplicada',
  'Observabilidade',
  'Cloud Fundamentals',
  'Gestao de Produtos',
  'Comunicacao Eficaz',
  'Lideranca Tecnica',
];

export const coursesMock: Course[] = [
  courseMock,
  ...courseTitles.map((title, index) => {
    const category = categoriesMock[index % categoriesMock.length];

    return {
      id: `course-${index + 1}`,
      tenantId: 'tenant-uuid',
      title,
      description: `Curso de ${title}`,
      category,
      groupIds: ['group-uuid'],
      trackIds: [],
      createdAt: now,
      updatedAt: now,
      status: index < 3
        ? CourseStatus.DRAFT
        : index % 5 === 0
          ? CourseStatus.INACTIVE
          : CourseStatus.ACTIVE,
      isActive: index >= 3 && index % 5 !== 0,
      deletedAt: index === 4
        ? tenHoursAgo
        : null,
    };
  }),
];
